// extracted by mini-css-extract-plugin
module.exports = {"mobileLink":"mobile-link-module--mobile-link--1koMs","specify":"mobile-link-module--specify--Z858t"};